import HeroSection from '../../components/LocationPages/HeroSection';
import MiddleSection from '../../components/LocationPages/MiddleSection';

const data = {
  seo: {
    title: 'Financial Planner in Sydney | PFGS Lewisham NSW',
    description:
      'Personalised financial planning, super and retirement advice from PFGS advisors in Lewisham, Sydney. Free initial consultation.',
    canonical: 'https://pfgs.com.au/location-sydney',
  },
  heroTitle: 'Your Trusted Financial Planning Experts in Sydney',
  heroDescription: 'G2/5 McGill Street, Lewisham NSW 2049, Australia',
  location: 'Sydney',
  mainTitle: 'Personalised Financial Advice to Secure Your Future',
  introText: [
    "At PFGS, we're dedicated to helping Sydney residents build, protect, and grow their wealth. Whether you're planning for retirement, buying your first home, managing debt, or looking to invest smarter — our experienced financial advisors in Sydney are here to provide clear, tailored guidance every step of the way.",
    "We understand that no two financial journeys are the same. That's why we take the time to listen, understand your goals, and develop a plan that aligns with your lifestyle and long-term ambitions.",
  ],
  whyChooseTitle: 'Why Choose PFGS as Your Sydney Financial Advisor?',
  reasons: [
    {
      title: 'Sydney-Based Experts:',
      description:
        'We know the Sydney market — from property prices to cost-of-living challenges and investment trends — and tailor our strategies accordingly.',
    },
    {
      title: 'Comprehensive Financial Planning:',
      description: 'We cover everything from budgeting and superannuation to insurance, debt management, and investment portfolios.',
    },
    {
      title: 'Access to Trusted Lenders & Partners:',
      description: 'We work with a network of financial institutions and lenders to ensure you always get competitive solutions.',
    },
    {
      title: 'Transparent, Ongoing Support:',
      description: 'We believe financial advice should be clear and continuous, not a one-off meeting. We stay with you for the long term.',
    },
    {
      title: 'Tailored to You:',
      description: 'Our Sydney financial planners create strategies built around your goals — not generic templates or product quotas.',
    },
  ],
  servicesTitle: 'Our Financial Services in Sydney',
  services: [
    {
      title: '1. Financial Planning',
      description:
        "Our certified financial planners in Sydney provide end-to-end advice — from setting achievable goals to implementing and reviewing your plan. We'll help you:",
      bullets: [
        'Create a realistic savings strategy',
        'Build and protect wealth',
        'Reduce financial stress through smart budgeting',
        'Set up structures that support long-term financial growth',
      ],
    },
    {
      title: '2. Investment Advice & Wealth Management',
      description:
        'We help Sydney investors navigate the complexities of the market with confidence. Our wealth management strategies balance risk and reward, giving you a clear roadmap for growth.',
    },
    {
      title: '3. Superannuation & Retirement Planning',
      description:
        'Our Sydney retirement planning advisors help you optimise your superannuation and retirement income, ensuring you can enjoy financial freedom when you need it most.',
    },
    {
      title: '4. Insurance & Risk Protection',
      description:
        "Life is unpredictable — but your financial future shouldn't be. We review your insurance cover to protect what matters most: your family, income, and assets.",
    },
    {
      title: '5. Debt Management & Cash Flow',
      description:
        'Our financial advisors in Sydney can help you reduce debt faster, improve cash flow, and make smarter use of your income so you stay ahead of rising living costs.',
    },
  ],
  whoWeHelpTitle: 'Who We Help',
  whoWeHelp: [
    {
      title: 'Professionals & Families:',
      description: 'Balancing income, lifestyle, and future goals in a competitive Sydney market.',
    },
    {
      title: 'Self-Employed & Business Owners:',
      description: 'Structuring finances for tax efficiency, growth, and financial security.',
    },
    {
      title: 'First Home Buyers:',
      description: 'Building a financial foundation for property ownership in Sydney.',
    },
    {
      title: 'Investors:',
      description: 'Building wealth through diversified, strategic investment portfolios.',
    },
    {
      title: 'Pre-Retirees & Retirees:',
      description: 'Maximising superannuation and ensuring peace of mind through smart income strategies.',
    },
  ],
  aboutTitle: 'About PFGS',
  aboutText: [
    'At PFGS, we believe great financial advice starts with trust, clarity, and genuine understanding. Our Sydney-based financial advisors are committed to helping you achieve your goals — no jargon, no hidden agendas, just practical guidance that works for you.',
    "Whether you're navigating complex financial decisions or simply want a clearer path forward, our team is ready to help you make confident, informed choices for your financial future.",
  ],
  ctaTitle: "Let's Build Your Financial Future Together",
  ctaText:
    "Take the first step toward financial confidence. Contact PFGS – Sydney's trusted financial advisors – today for a complimentary initial consultation.",
  sidebarTitle: 'Ready To Get Started?',
  sidebarText: 'Speak with one of our experienced financial advisors to discover your options and available opportunities in Sydney.',
};

const SydneyLocation = () => {
  return (
    <div>
      <HeroSection data={data} />
      <MiddleSection data={data} />
    </div>
  );
};

export default SydneyLocation;
